import SchemaMismatchError from "services/validators/SchemaMismatchError";

export const ZOD_ERROR_CODE = "ZodParseSchemaError"

export const Language = Object.freeze({
    ENGLISH: "en",
    FRENCH: "fr"
});

export const swrGlobalConfig = {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    onError(err: any, key: string) {
        SchemaMismatchError(key, err)
    }
}

export const Province = [
    { value: "AB", label: "Options.Province.ab" },
    { value: "BC", label: "Options.Province.bc" },
    { value: "MB", label: "Options.Province.mb" },
    { value: "NB", label: "Options.Province.nb" },
    { value: "NL", label: "Options.Province.nl" },
    { value: "NS", label: "Options.Province.ns" },
    { value: "NT", label: "Options.Province.nt" },
    { value: "NU", label: "Options.Province.nu" },
    { value: "ON", label: "Options.Province.on" },
    { value: "PE", label: "Options.Province.pe" },
    { value: "QC", label: "Options.Province.qc" },
    { value: "SK", label: "Options.Province.sk" },
    { value: "YT", label: "Options.Province.yt" },
]

export const roleOrder = [
    "ROLE_TPSC_ACADEMY_DEVELOPER",
    "ROLE_TPSC_ACADEMY_WRITER",
    "ROLE_TPSC_ACADEMY_INSTRUCTOR",
    "ROLE_TPSC_ACADEMY_STUDENT"
];